import { Icons } from './Icons';
import { useInView, useCountUp } from '../hooks';
import styles from './Tokenomics.module.css';

function MeterBar({ label, pct, color = '#3B82F6', delay = 0 }) {
  const [ref, inView] = useInView(0.3);
  return (
    <div ref={ref} className={styles.meter}>
      <div className={styles.meterHeader}>
        <span className={styles.meterLabel}>{label}</span>
        <span className={styles.meterPct} style={{ color }}>{pct}%</span>
      </div>
      <div className={styles.meterTrack}>
        <div
          className={styles.meterFill}
          style={{
            width: inView ? `${pct}%` : '0%',
            background: `linear-gradient(90deg, ${color}, #06B6D4)`,
            transition: `width 1.4s cubic-bezier(0.22,1,0.36,1) ${delay}s`,
          }}
        />
      </div>
    </div>
  );
}

export default function Tokenomics({ t }) {
  const [ref, inView] = useInView(0.15);
  const count = useCountUp(50, 1600, inView);

  return (
    <section className={styles.section} id="tokenomics">
      <div className={styles.inner}>
        {/* LEFT — big number */}
        <div ref={ref} className={styles.left}>
          <div className={styles.label}>{t.sectionLabel}</div>
          <div className={styles.bigNumber}>{count}%</div>
          <p className={styles.bigSub}>{t.sub}</p>
          <div className={styles.tags}>
            {[t.tag1, t.tag2, t.tag3].map(tag => (
              <div key={tag} className={styles.tag}>
                <Icons.Check /> {tag}
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT — bars */}
        <div className={styles.right}>
          <h3 className={styles.rightTitle}>{t.title}</h3>
          <MeterBar label={t.bar1} pct={50} color="#3B82F6" delay={0}   />
          <MeterBar label={t.bar2} pct={35} color="#0891B2" delay={0.2} />
          <MeterBar label={t.bar3} pct={15} color="#0E7490" delay={0.4} />
          <div className={styles.note}>
            <strong className={styles.noteHighlight}>{t.noteHighlight}</strong>{' '}
            {t.note.replace(t.noteHighlight, '').trim()}
          </div>
        </div>
      </div>
    </section>
  );
}
